document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-puro-slider]').forEach((slider) => {
    const rail = slider.querySelector('[data-puro-slider-rail]');
    if (!rail) return;

    slider.querySelector('[data-puro-prev]')?.addEventListener('click', () => {
      rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' });
    });

    slider.querySelector('[data-puro-next]')?.addEventListener('click', () => {
      rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' });
    });
  });
});
